import { Button, H1, Paragraph, Prose } from '@sbab-ui/components'
import { AppAction } from '../appState'
import AppHeader from './AppHeader'
import kw_icon from '../assets/KW_ikon.png'
import kw_icon_mobile from '../assets/KW_ikon_mobil.svg'

interface Props {
  appDispatch: React.Dispatch<AppAction>
}

export default function LandingContent({ appDispatch }: Readonly<Props>) {
  return (
    <div className="flex min-h-screen flex-col">
      <AppHeader variant="dark" />
      <div className="relative flex grow flex-col justify-center overflow-auto text-left lg:ml-2">
        <div className="my-4 -mt-12 ml-2 md:ml-36 lg:hidden">
          <img
            src={kw_icon_mobile}
            alt="ikon"
            className="h-auto w-40 max-w-full"
            aria-label="Ikon Kilowattkalkylen"
          />
        </div>
        <Prose className="!ml-3 text-white  md:!ml-36 lg:!w-[500px]">
          <H1 data-cy="modal-h1" className="lg:display-block !mb-[22px] text-white lg:!mb-[24px]">
            Kilowattkalkylen
          </H1>
          <Paragraph size="h3" className="lg:!mb-[24px]">
            Nyfiken på att byta värmekälla eller installera solceller? Ta reda på hur du kan sänka
            dina kostnader med Kilowattkalkylen.
          </Paragraph>
          <ol className="lg:!mb-[40px]">
            <li>
              <Paragraph>1. Svara på några frågor om ditt hus</Paragraph>
            </li>
            <li>
              <Paragraph>2. Få förslag på åtgärder och vad du kan spara</Paragraph>
            </li>
            <li>
              <Paragraph>3. Se hur du kan göra verklighet av planerna</Paragraph>
            </li>
          </ol>
        </Prose>
        <Button
          aria-label="Knapp starta kalkylen"
          className="!lg:mx-5 !lg:mb-10 !mx-2 !mb-20
          !mt-5  !p-7 !text-xl md:!ml-36 md:!w-1/2  lg:!w-36"
          data-testid="start-button"
          onClick={() => appDispatch({ type: 'goForward' })}
        >
          Starta
        </Button>

        <div></div>
      </div>

      <div className="absolute bottom-0 right-0 hidden lg:block" aria-label="Ikon Kilowattkalkylen">
        <img src={kw_icon} alt="Ikon" />
      </div>
    </div>
  )
}
